/*global $ */

export function setupSiteSearch($siteSearchInput) {
  // サイト内検索
  $siteSearchInput.on('keyup', e => { if (e.keyCode === 13) executeSiteSearch(); });
  $('#site-search > .custom-search > button').on('click', () => executeSiteSearch());
  // 検索ページに遷移
  function executeSiteSearch() {
    if ($siteSearchInput.val() !== '') {
      window.location.href = document.baseURI + '/key_search?query=' + encodeURIComponent($siteSearchInput.val());
    }
  }
}